export default __webpack_public_path__ + "static/media/Bandit's Jerkin of World's Edge.f5bbaa23.jpg";